module.exports = __webpack_public_path__ + "img/lait1age.13f9f812.png";